import CrossTabConfig from '../calling-cross-tab-utils/CrossTabConfig';
import { logDebugMessage } from '../calling-cross-tab-utils/getCrossTabEmbedDebugger';
import { ConnectionTypes } from 'calling-cross-tab-library/types/ConnectionTypes';
import { CallWidgetStates } from 'calling-internal-common/widget-status/constants/CallWidgetStates';
import WorkerConnection from '../WorkerConnection';
import { createResetActiveCallDetailsMessage } from 'calling-cross-tab-library/messages/ToWorkerMessages';
export class _ActiveCallManager {
  constructor() {
    this._shouldResetActiveCallData = false;
    this.resetActiveData = connectionId => {
      this._shouldResetActiveCallData = false;
      logDebugMessage('ActiveCallManager - resetting activeCallDetails');
      WorkerConnection.sendMessage(createResetActiveCallDetailsMessage(connectionId));
    };
    this.queueActiveDataResetOnDisconnect = () => {
      if (!this._shouldResetActiveCallData) {
        logDebugMessage('ActiveCallManager - adding handler');
        this._shouldResetActiveCallData = true;
      }
    };
    this.maybeUnqueueActiveDataResetOnDisconnect = widgetDetails => {
      const {
        connectionType
      } = CrossTabConfig.get();
      if (!this._shouldResetActiveCallData || connectionType !== ConnectionTypes.EXTERNAL) return;
      const {
        callStatus,
        activeCallDetails
      } = widgetDetails;
      if (callStatus === CallWidgetStates.READY && activeCallDetails === undefined) {
        logDebugMessage('ActiveCallManager - removing handler');
        this._shouldResetActiveCallData = false;
      }
    };
  }
  get shouldResetActiveCallData() {
    return this._shouldResetActiveCallData;
  }
}
export default new _ActiveCallManager();